module.exports = __webpack_public_path__ + "static/media/step-indicator-1.d98dd14c.svg";